import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "@store/api/baseQueries";

export const reportApi = createApi({
  reducerPath: "reportApi",
  baseQuery: customBaseQuery(
    fetchBaseQuery({
      baseUrl: `${process.env.REACT_APP_ZOOMAPP_BACKEND_BASE_URL}/report`,
    }),
  ),
  endpoints: (builder) => {
    return {
      getAgendaReport: builder.query({
        query: (query) => ({
          url: `/`,
          method: "GET",
          params: query
        }),
      }),
      checkEReportAccess: builder.mutation({
        query: ({ agendaId }) => ({
          url: `/${agendaId}/e-report/check`,
          method: "GET",
        }),
      }),      
    };
  },
});

export const { useGetAgendaReportQuery, useCheckEReportAccessMutation } = reportApi;
